import React from 'react'

class Delete extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21">
        <path
          fill="#999999"
          d="M17.5 4.2l-.6 12.7c-.1 1.1-1 2-2.1 2H6.2c-1.1 0-2-.9-2.1-2L3.5 4.2h1.4l.6 12.6c0 .4.3.7.7.7h8.5c.4 0 .7-.3.7-.7L16 4.2H4.9l.6 12.6c0 .4.3.7.7.7h8.5c.4 0 .7-.3.7-.7L16 4.2h1.5l-.6 12.7c-.1 1.1-1 2-2.1 2H6.2c-1.1 0-2-.9-2.1-2L3.5 4.2h-.7c-.4 0-.7-.3-.7-.7s.3-.7.7-.7h4.9v-.7c0-.6.5-1 1.1-1h3.5c.6 0 1.1.5 1.1 1v.7h4.9c.4 0 .7.3.7.7s-.3.7-.7.7h-.8zM8.4 2.8h4.2v-.7c0-.2-.2-.3-.4-.3H8.8c-.2 0-.4.2-.4.3v.7z"
        />
        <path fill="#999999" d="M10 6.8h1v8.1h-1z" />
        <path fill="#999999" d="M12.8 8.2h1v5.3h-1z" />
        <path fill="#999999" d="M7.2 8.2h1v5.3h-1z" />
      </svg>
    )
  }
}

export default Delete
